import s from "./style.module.scss";
import clsx from "clsx";
import Cross from "@/assets/cross.svg?react";

interface CategoryPatchProps {
  onRemove: (arg0: number | string) => void;
  id: number | string;
  label?: React.ReactNode;
  colorType: "green" | "grey";
}

export const CategoryPatch = ({
  onRemove,
  id,
  label,
  colorType,
}: CategoryPatchProps) => {
  return (
    <div className={clsx(s.patch, s[colorType])}>
      <span>{label}</span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onRemove(id);
        }}
      >
        <Cross />
      </button>
    </div>
  );
};
